import React from 'react';
import { 
  Shield, 
  CheckCircle, 
  Database, 
  ClipboardCheck, 
  GraduationCap,
  ArrowRight 
} from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { useContent } from '../hooks/useContent';

export const ServicesSection = () => {
  const { content, loading } = useContent();
  
  if (loading || !content) {
    return (
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-navy-900 text-xl">Loading services...</div>
        </div>
      </section>
    );
  }

  const { services } = content;

  const serviceIcons = [
    <Shield className="h-8 w-8 text-blue-600" />,
    <CheckCircle className="h-8 w-8 text-green-600" />,
    <Database className="h-8 w-8 text-purple-600" />,
    <ClipboardCheck className="h-8 w-8 text-orange-600" />,
    <GraduationCap className="h-8 w-8 text-indigo-600" />
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-navy-900 mb-4">
            {services.sectionTitle.split(' ')[0]} <span className="text-blue-600">{services.sectionTitle.split(' ')[1]}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {services.sectionDescription}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.items.map((service, index) => (
            <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-200">
              <CardHeader className="pb-4">
                <div className="mb-4 group-hover:scale-110 transition-transform duration-300">
                  {serviceIcons[index] || <Shield className="h-8 w-8 text-blue-600" />}
                </div>
                <CardTitle className="text-xl text-navy-900 group-hover:text-blue-600 transition-colors duration-300">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </CardDescription>
                <a 
                  href={`/services#${service.id}`}
                  className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold group/btn"
                >
                  Learn More
                  <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform duration-200" />
                </a>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Industries Pills */}
        <div className="text-center">
          <h3 className="text-2xl font-semibold text-navy-900 mb-6">Industries We Serve</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {services.industries.map((industry) => (
              <span 
                key={industry}
                className="px-6 py-3 bg-blue-50 text-blue-700 rounded-full font-medium hover:bg-blue-100 transition-colors duration-200 cursor-default"
              >
                {industry}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};